<template>
  <v-card>
    <v-toolbar flat>
      <span class="headline">Application Review Approval</span>
      <v-spacer></v-spacer>
      <v-btn icon @click="hideDialog">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="card-container" style="margin-top: 5px">
      <div>
        <v-layout row>
          <v-flex lg3>
            <v-subheader class="field-style">Withdrawn Category</v-subheader>
          </v-flex>
          <v-flex lg3>
            <v-select
              v-model="approvalData.withdrawnCategory"
              :items="approvalFormEnum.withdrawnCategoryArray"
              :disabled="filedDisable.withdrawnCategoryDisable"
              item-text="text"
              item-value="value"
              hide-details
            ></v-select>
          </v-flex>
          <v-flex lg3>
            <v-subheader class="field-style">Special Approval</v-subheader>
          </v-flex>
          <v-flex lg3>
            <v-select
              v-model="approvalData.specialApproval"
              :items="approvalFormEnum.specialApprovalArray"
              :disabled="filedDisable.denyDisable"
              @change="disableAction()"
              item-text="text"
              item-value="value"
              hide-details
            ></v-select>
          </v-flex>
          <v-flex lg3>
            <v-subheader class="field-style">Call Review</v-subheader>
          </v-flex>
          <v-flex lg3>
            <v-select
              v-model="approvalData.callReview"
              :items="approvalFormEnum.callReviewArray"
              :disabled="filedDisable.denyDisable"
              item-text="text"
              item-value="value"
              hide-details
            ></v-select>
          </v-flex>
          <v-flex lg3>
            <v-subheader class="field-style">Special Approval Type</v-subheader>
          </v-flex>
          <v-flex lg3>
            <v-select
              v-model="approvalData.specialApprovalType"
              :items="approvalFormEnum.specialApprovalTypeArray"
              :disabled="filedDisable.specialApprovalDisable"
              item-text="text"
              item-value="value"
              hide-details
            ></v-select>
          </v-flex>
          <v-flex lg3>
            <v-subheader class="field-style">Type Of Review</v-subheader>
          </v-flex>
          <v-flex lg3>
            <v-select
              v-model="approvalData.typeOfReview"
              :items="approvalFormEnum.loanReviewArray"
              :disabled="filedDisable.denyDisable"
              item-text="text"
              item-value="value"
              hide-details
            ></v-select>
          </v-flex>
          <v-flex lg3>
            <v-subheader class="field-style">Special Approval Authorizer</v-subheader>
          </v-flex>
          <v-flex lg3>
            <v-menu
              v-model="specialApprovalInfo.showDetail"
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="approvalData.specialApprovalAuthorizer"
                  :disabled="filedDisable.specialApprovalDisable"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-card>
                <v-card-actions>
                  <input type="text" class="content-input" v-model="specialApprovalInfo.selectNo" v-on:input="getEmployeeInfo" placeholder="Please Enter Employee#"/>
                </v-card-actions>
                <v-card max-height="200px" max-width="240px">
                  <v-list>
                    <v-list-item v-for="(item,index) in specialApprovalInfo.data" :key="index" @click="chooseItem($event)">{{item.display}}</v-list-item>
                  </v-list>
                </v-card>
              </v-card>
            </v-menu>
          </v-flex>
        </v-layout>
      </div>
    </v-card-text>
    <v-card-actions class="pb-3">
      <v-spacer></v-spacer>
      <v-btn class="save-button" color="blue darken-1" text @click="saveAction">Save</v-btn>
      <v-btn class="save-button" color="blue darken-1" text @click="hideDialog">Cancel</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { Tool, Popup } from '@/util/index'
import { DictionaryApi, EmployeeApi } from '@/api/pandaria'
const tool = new Tool()
const popup = new Popup()
export default {
  name: 'approval-form-dialog',
  props: {
    actionType: String
  },
  data () {
    return {
      approvalData: {
        withdrawnCategory: null,
        specialApproval: null,
        callReview: null,
        specialApprovalType: null,
        typeOfReview: null,
        specialApprovalAuthorizer: null
      },
      approvalFormEnum: {
        withdrawnCategoryArray: [],
        callReviewArray: [],
        loanReviewArray: [],
        specialApprovalTypeArray: [],
        specialApprovalArray: [
          { text: 'Yes', value: true },
          { text: 'No', value: false }
        ]
      },
      filedDisable: {
        denyDisable: false,
        withdrawnCategoryDisable: false,
        specialApprovalDisable: false
      },
      flags: null,
      specialApprovalType: null,
      typeOfReview: null,
      specialApprovalInfo: {
        showDetail: false,
        isSearch: false,
        data: [],
        displayEmpNo: Number,
        selectNo: '',
        showData: ''
      }
    }
  },
  mounted () {
    if (tool.isEmpty(this.approvalFormEnum.withdrawnCategoryArray)) {
      this.getDomainByCode('WITHDRAWN_CATEGORY', this.approvalFormEnum.withdrawnCategoryArray)
    }
    if (tool.isEmpty(this.approvalFormEnum.callReviewArray)) {
      this.getDomainByCode('CALL_REVIEW_TYPE', this.approvalFormEnum.callReviewArray)
    }
    if (tool.isEmpty(this.approvalFormEnum.loanReviewArray)) {
      this.getDomainByCode('LOAN_REVIEW_TYPE', this.approvalFormEnum.loanReviewArray)
    }
    if (tool.isEmpty(this.approvalFormEnum.specialApprovalTypeArray)) {
      this.getDomainByCode('SPECIAL_APPROVAL_TYPE', this.approvalFormEnum.specialApprovalTypeArray)
    }
    this.initPage()
  },
  methods: {
    initPage () {
      this.approvalData = {
        withdrawnCategory: null,
        specialApproval: null,
        callReview: null,
        specialApprovalType: null,
        typeOfReview: null,
        specialApprovalAuthorizer: null
      }
      this.specialApprovalInfo = {
        isSearch: false,
        rules: [true],
        data: [],
        showDetail: false
      }
      if (this.actionType === '24002') {
        this.filedDisable.denyDisable = true
        this.filedDisable.specialApprovalDisable = true
      } else {
        this.filedDisable.withdrawnCategoryDisable = true
        this.filedDisable.denyDisable = false
        this.filedDisable.specialApprovalDisable = false
      }
    },
    disableAction () {
      if (!this.approvalData.specialApproval) {
        this.approvalData.specialApprovalType = null
        this.approvalData.specialApprovalAuthorizer = null
        this.specialApprovalInfo = {
          isSearch: false,
          rules: [true],
          data: [],
          showDetail: false
        }
        this.filedDisable.specialApprovalDisable = true
      } else {
        this.filedDisable.specialApprovalDisable = false
      }
    },
    getDomainByCode (code, enumArray) {
      DictionaryApi.listDomainByCode(code, function (result) {
        for (const item of result) {
          enumArray.push({
            text: item.text,
            value: item.value
          })
        }
      })
    },
    getEmployeeInfo () {
      const $this = this
      if ($this.specialApprovalInfo.selectNo.toString().length === 0) {
        $this.specialApprovalInfo.data = []
      } else if ($this.specialApprovalInfo.selectNo.toString().length > 0) {
        const requestData = { employeeInfo: this.specialApprovalInfo.selectNo }
        EmployeeApi.searchEmployeeInfo(requestData, function (result) {
          if (tool.isNotEmpty(result) && requestData.employeeInfo === $this.specialApprovalInfo.selectNo) {
            $this.specialApprovalInfo.data = []
            for (const item of result) {
              item.display = item.employeeNo + ' | ' + tool.getFullName(item)
              $this.specialApprovalInfo.data.push(item)
            }
            $this.specialApprovalInfo.isSearch = true
          }
        })
      }
    },
    chooseItem (e) {
      const selectEmployeeData = this.specialApprovalInfo.data.find(ele => ele.display === e.target.innerText)
      this.specialApprovalInfo.showData = selectEmployeeData
      this.approvalData.specialApprovalAuthorizer = selectEmployeeData.employeeNo
      this.specialApprovalInfo.isSearch = false
      this.specialApprovalInfo.showDetail = false
      this.specialApprovalInfo.selectNo = ''
      this.specialApprovalInfo.data = []
    },
    saveAction () {
      const underwriterApproval = {}
      underwriterApproval.actionType = this.actionType
      if (this.actionType === '24001') {
        underwriterApproval.flags = this.approvalData.specialApproval ? 1 : -1
        underwriterApproval.reviewType = this.approvalData.typeOfReview
        underwriterApproval.callType = this.approvalData.callReview
        underwriterApproval.specialApprovalType = this.approvalData.specialApprovalType
        if (this.approvalData.specialApproval && tool.isNotEmpty(this.specialApprovalInfo.showData)) {
          underwriterApproval.specialApprovalAuthorizer = this.specialApprovalInfo.showData.id
        }
      } else {
        underwriterApproval.withdrawnCategory = this.approvalData.withdrawnCategory
      }
      if (
        (underwriterApproval.actionType === '24001' && tool.isNotEmpty(underwriterApproval.callType) &&
          tool.isNotEmpty(underwriterApproval.reviewType) && underwriterApproval.flags === -1 &&
          tool.isEmpty(underwriterApproval.specialApprovalType) && tool.isEmpty(underwriterApproval.specialApprovalAuthorizer)) ||
        (underwriterApproval.actionType === '24001' && tool.isNotEmpty(underwriterApproval.callType) &&
          tool.isNotEmpty(underwriterApproval.reviewType) && underwriterApproval.flags === 1 &&
          tool.isNotEmpty(underwriterApproval.specialApprovalType) && tool.isNotEmpty(underwriterApproval.specialApprovalAuthorizer)) ||
        (underwriterApproval.actionType === '24002' && tool.isNotEmpty(underwriterApproval.withdrawnCategory))
      ) {
        this.$emit('saveUnderwriterApproval', underwriterApproval)
        this.initPage()
      } else {
        popup.popupForWarning('Please fill in the form')
      }
    },
    hideDialog () {
      this.$emit('hideDialog')
    }
  }
}
</script>
<style lang="css" scoped>
.field-style {
  padding-top: 20px;
}
.content-input {
  -webkit-appearance: none;
  background-color: #fff;
  font-size: 14px;
  display: block;
  box-sizing: border-box;
  width: 96%;
  border: 1px solid rgba(0,0,0,.14);
  padding: 8px 13px;
  margin: 10px auto;
  border-radius: 2px;
  transition: border-color .2s;
}
</style>
